export default {
    API: {
        endpoint: 'https://accounts.xenfuma.com'
    }
}